import { useMutation } from '@apollo/client';
import { GROUPS_VIEW_QUERY } from './GroupsView';
import { useAppDispatch } from '../app/redux/useAppSelector';
import ConfirmationModal from '../components/ConfirmationModal';
import { gql } from '../graphql/generated/gql';
import { UIActions } from '../ui/uiSlice';
import { legacyUpdateQueryList } from '../utils/graphql/updateQueryList';
import useNavigate from '../utils/router/useNavigate';

const DELETE_GROUP_MUTATION = gql(/** @complexity 2 */ `
  mutation GroupModalDelete($id: ID!) {
    deleteGroup(id: $id) {
      id
    }
  }
`);

const useDeleteGroup = (id: string | null) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [deleteGroup] = useMutation(DELETE_GROUP_MUTATION);

  if (!id) {
    return null;
  }

  return () =>
    new Promise((resolve, reject) => {
      dispatch(
        UIActions.openModal(ConfirmationModal, {
          title: 'Delete this group?',
          message: 'Deleted groups are gone forever.',
          confirmButtonText: 'Delete',
          onConfirm: async () => {
            const promise = deleteGroup({
              variables: { id },
              update: legacyUpdateQueryList(
                { query: GROUPS_VIEW_QUERY },
                'session.organization.groups',
                'deleteGroup',
                false,
              ),
            });

            navigate('/groups');

            await promise.then(resolve).catch(reject);
          },
        }),
      );
    });
};

export default useDeleteGroup;
